import {useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import './style.css'
import DashboardCards from './DashboardCards'
import SearchFilterBar from '../Pengajuan/SearchFilterBar'
import AlumniTable from './AlumniTable'
const api = new Api()

const DashboardContent = () => {
  const [query, setQuery] = useState({})
  const [statistic, setStatistic] = useState({})

  const handleInputFilter = (data: any) => {
    setQuery(data)
  }

  const handleStatistic = (data: any) => {
    setStatistic(data)
  }

  return (
    <div className='row'>
      <DashboardCards />

      <div className='px-3 pt-5'>
        <SearchFilterBar
          handleInputFilter={handleInputFilter}
          status={['publish', 'unpublished']}
          statusName='publish_status'
        />
      </div>

      <div className='px-3 pt-5'>
        <AlumniTable dataFilter={query} handleStatistic={handleStatistic} />
      </div>
    </div>
  )
}

const AlumniProfile = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Frop',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Profil Alumni
      </PageTitle>
      <DashboardContent />
    </>
  )
}

export default AlumniProfile
